import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiMail } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-zinc-200 pt-20 pb-10 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="text-2xl font-bold tracking-tighter text-zinc-950 flex items-center gap-2 mb-6">
              <div className="w-8 h-8 bg-zinc-950 rounded flex items-center justify-center">
                <div className="w-4 h-4 border-2 border-white rounded-sm rotate-45" />
              </div>
              Data Risk Audit
            </Link>
            <p className="text-zinc-500 max-w-sm leading-relaxed mb-6">
              Empowering individuals and founders to understand their digital exposure through manual, expert-led data risk assessments.
            </p>
            <div className="flex items-center gap-2 text-zinc-900 font-medium">
              <SafeIcon icon={FiMail} className="w-5 h-5" />
              <a href="mailto:hello@datariskaudit.com" className="hover:underline">hello@datariskaudit.com</a>
            </div>
          </div>
          
          <div>
            <h4 className="font-bold text-zinc-950 mb-6 uppercase tracking-wider text-xs">Product</h4>
            <ul className="space-y-4 text-zinc-600">
              <li><a href="#/how-it-works" className="hover:text-zinc-950 transition-colors font-medium">How it Works</a></li>
              <li><a href="#/example" className="hover:text-zinc-950 transition-colors font-medium">Sample Report</a></li>
              <li><a href="#/pricing" className="hover:text-zinc-950 transition-colors font-medium">Pricing</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-zinc-950 mb-6 uppercase tracking-wider text-xs">Legal & Support</h4>
            <ul className="space-y-4 text-zinc-600">
              <li><a href="#/faq" className="hover:text-zinc-950 transition-colors font-medium">FAQ</a></li>
              <li><Link to="/privacy" className="hover:text-zinc-950 transition-colors font-medium">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-zinc-950 transition-colors font-medium">Terms of Service</Link></li>
              <li><a href="mailto:hello@datariskaudit.com" className="hover:text-zinc-950 transition-colors font-medium">Contact Us</a></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-10 border-t border-zinc-100 flex flex-col md:flex-row justify-between items-center gap-4 text-zinc-400 text-sm">
          <p>© {new Date().getFullYear()} Data Risk Audit. All rights reserved.</p>
          <div className="flex gap-8">
            <Link to="/terms" className="hover:text-zinc-600 transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-zinc-600 transition-colors">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;